// Angular modules
import { HttpRequest }     from '@angular/common/http';
import { HttpHandler }     from '@angular/common/http';
import { HttpEvent }       from '@angular/common/http';
import { HttpInterceptor } from '@angular/common/http';
import { Injectable }      from '@angular/core';

// External modules
import { Auth }            from 'aws-amplify';
import { Observable }      from 'rxjs';
import { from }            from 'rxjs';
import { mergeMap }        from 'rxjs/operators';

// Services
import { AuthService }     from '../services/auth.service';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor
{

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return from(Auth.currentAuthenticatedUser()
      .catch(_ => null)
      .then(usr => {
        if (usr == null) {
          return null;
        } else {
          return Auth.currentSession();
        }
      }))
      .pipe(
        mergeMap((session : any) => {
          if (session != null) {
            const businessProfile = JSON.parse(localStorage.getItem(AuthService.BusinessProfileKey));
            if (businessProfile?.id) {
              request = request.clone({
                setHeaders: {
                  Authorization: session.getIdToken().getJwtToken(),
                  'business-profile-id': businessProfile.id
                }
              });
            } else {
              request = request.clone({
                setHeaders: {
                  Authorization: session.getIdToken().getJwtToken(),
                  'Content-Type': 'application/json'
                }
              });
            }
          }
          return next.handle(request);
        })
      );
  }
}
